import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms'
import { TypedFormGroup } from '@feature/forms/form-model';;

import { FormOption } from '../form-option';

@Component({
    selector: 'wai-form-choice-slider',
    templateUrl: './form-choice-slider.component.html',
    styleUrls: ['./form-choice-slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormChoiceSliderComponent implements OnChanges {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  @Input() public control: FormControl;
  @Input() public options: FormOption[];

  public get value(): string | number | boolean {
    return this.options[this.sliderValue].value;
  }

  public set value(val: string | number) {
    this.sliderValue = this.valuesMap.get(val) || 0;
  }

  public sliderValue: number;

  private valuesMap = new Map<string | number | boolean, number>();

  public ngOnChanges(): void {
    this.options.map((val, index) => this.valuesMap.set(val.value, index));
    this.value = this.control.value;
  }

  public onSliderChange(value: number): void {
    this.sliderValue = value;

    if (this.value !== this.control.value) {
      this.control.patchValue(this.value);
      this.control.markAsDirty();
      this.control.markAsTouched();
    }
  }
}
